import { purgeThreadOnDelete } from './purgeThreadOnDelete'

/** @param {{ id: string }} thread @param {object} m */
export function handleThreadMenuDelete(thread, m) {
  if (!window.confirm('Delete this thread? This cannot be undone.')) return
  purgeThreadOnDelete({
    tid: thread.id,
    messagesByThreadId: m.messagesByThreadId,
    chatAbortRef: m.chatAbortRef,
    setActiveQueryVersionByExchangeId: m.setActiveQueryVersionByExchangeId,
    setActiveAnswerVersionByExchangeId: m.setActiveAnswerVersionByExchangeId,
    setThreads: m.setThreads,
    setPinnedThreadIds: m.setPinnedThreadIds,
    setMessagesByThreadId: m.setMessagesByThreadId,
    setSelectedThreadId: m.setSelectedThreadId,
    setDismissedNoteThreadIds: m.setDismissedNoteThreadIds,
    urlThreadId: m.urlThreadId,
    navigate: m.navigate,
  })
}
